export class Stay22Helper {
    public static getStay22InnerHTML(): string  {
        const stay22Element = document.querySelector('[data-js=stay22-container]');
        return stay22Element ? stay22Element.innerHTML : '';
    }
}